/**
 * Composant visuel d'étiquette énergétique A-G.
 * Couleurs alignées sur le standard DPE 2021.
 */

type EnergyClass = "A" | "B" | "C" | "D" | "E" | "F" | "G";

const COLORS: Record<EnergyClass, string> = {
  A: "bg-green-700 text-white",
  B: "bg-green-500 text-white",
  C: "bg-lime-400 text-gray-900",
  D: "bg-yellow-400 text-gray-900",
  E: "bg-orange-400 text-white",
  F: "bg-red-500 text-white",
  G: "bg-red-700 text-white",
};

const CLASSES: EnergyClass[] = ["A", "B", "C", "D", "E", "F", "G"];

export function EnergyLabel({
  label,
  size = "lg",
}: {
  label: string;
  size?: "sm" | "md" | "lg";
}) {
  const cls = (CLASSES.includes(label as EnergyClass) ? label : "G") as EnergyClass;
  const sizeClass =
    size === "sm" ? "h-8 w-8 text-sm" : size === "md" ? "h-12 w-12 text-lg" : "h-20 w-20 text-3xl";
  return (
    <span
      aria-label={`Étiquette énergétique ${cls}`}
      className={`inline-flex items-center justify-center rounded font-bold ${COLORS[cls]} ${sizeClass}`}
    >
      {cls}
    </span>
  );
}

/** Échelle complète A-G avec mise en évidence de la classe courante. */
export function EnergyLabelScale({ current }: { current: string }) {
  return (
    <div className="flex flex-col gap-1">
      {CLASSES.map((cls) => (
        <div
          key={cls}
          className={`flex h-8 items-center px-3 ${COLORS[cls]} ${
            cls === current ? "ring-4 ring-black ring-offset-1" : "opacity-70"
          }`}
          aria-current={cls === current ? "true" : undefined}
        >
          <span className="font-bold">{cls}</span>
        </div>
      ))}
    </div>
  );
}
